/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */
import Header from './header/Header';
import HeaderMessageNode from './HeaderMessageNode';
import HeaderCloseNode from './HeaderCloseNode';

const HeaderNode = ({
  headerHeight,
  headerTopMargin,
  messageRef,
  inquiry,
  isCloseBtnDisable,
  action,
  isFullscreen,
}) => {
  return (
    <Header
      headerHeight={headerHeight}
      marginTop={headerTopMargin}
      isFullscreen={isFullscreen}
    >
      <HeaderMessageNode messageRef={messageRef} inquiry={inquiry} />
      {/* header close */}
      <HeaderCloseNode isCloseBtnDisable={isCloseBtnDisable} action={action} />
    </Header>
  );
};

export default HeaderNode;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/HeaderNode.js